import React from 'react';
import CustomSwitch from '../../../../../shared/CustomSwitch/CustomSwitch';
import './SubscriberInfoHeader.css';

function SubscriberInfoHeader({ hidden, checked, onChange, subscriberData }) {
  const {
    name = 'Herman Hoff',
    subscriberId = '92550111078',
    email = 'joy1103@yahoo.com',
    currentPlan = 'Internet Service 50/50',
    accounts = [
      { id: '92554171828', number: '92551154622' }
    ],
    selectedAccount = '92554171828 - 92551154622'
  } = subscriberData || {};
 
  return (
    <div className={`subscriber-info-header ${hidden ? 'card-disabled' : ''}`}>
      <div className="subscriber-header-top">
        <h4 className="card-title"></h4>
        <CustomSwitch
          checked={checked}
          onChange={onChange}
          size="small"
          color="#2196f3"
        />
      </div>

      <div className="subscriber-info-content">
        <div className="subscriber-info-section">
          <label className="subscriber-info-label">Name</label>
          <div className="subscriber-info-value">{name}</div>
        </div>

        <div className="subscriber-info-section">
          <label className="subscriber-info-label">Subscriber ID</label>
          <div className="subscriber-info-value">{subscriberId}</div>
        </div>

        <div className="subscriber-info-section">
          <label className="subscriber-info-label">Email</label>
          <div className="subscriber-info-value">{email}</div>
        </div>

        <div className="subscriber-info-section">
          <label className="subscriber-info-label">Current Plan</label>
          <div className="subscriber-info-value">{currentPlan}</div>
        </div>

        <div className="subscriber-info-section">
          <label className="subscriber-info-label">Choose Account</label>
          <select className="subscriber-account-select" defaultValue={selectedAccount}>
            {accounts.map((account, index) => (
              <option key={index} value={`${account.id} - ${account.number}`}>
                {account.id} - {account.number}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
}

export default SubscriberInfoHeader;

